// src/App.js
import { useContext, useEffect, useState, useRef } from 'react';
import '../App.css';
import LanguageContext from './hooks/LanguageContext';
import html2canvas from 'html2canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import ModalInstruction from './ModalInstruction';
import { getText } from '../utils/languageUtils';


const Ikigai = ({ isMarked, question, textInputs, setTextInputs, textInputsAns, setTextInputsAns }) => {

    const { language, translations: translationData } = useContext(LanguageContext);
    const translations = translationData?.ikigai || {};
    const textOptions = question?.question_option;
    const captureRef = useRef(null);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        // Only set textInputs from textInputsAns if marked AND textInputsAns has data
        if (isMarked === 1 && textInputsAns && textInputsAns.length > 0) {
            setTextInputs(textInputsAns)
        }
    }, [isMarked, textInputsAns, setTextInputs])
    // Create a generic event handler to update the state
    const handleInputChange = (e, num) => {
        const { name, value } = e.target;
      
        setTextInputs((prevTextValue) =>
            prevTextValue.map((item) =>
                item.id === Number(num) ? { ...item, text: value } : item
            )
        );
        setTextInputsAns((prevTextValue) =>
            prevTextValue.map((item) =>
                item.id === Number(num) ? { ...item, text: value } : item
            )
        );
    };
    
    const handleCapture = () => {
        html2canvas(captureRef.current).then((canvas) => {
            const image = canvas.toDataURL('image/png');
            // You can save the 'image' data URL or display it as an image in your app.
            // Create a download link
            const a = document.createElement('a');
            a.href = image;
            a.download = 'captured_image.png';

            // Trigger a click event on the link to prompt the user to save the image
            a.click();
        });
    };
    return (
        <>
            <div className='justify-content-end d-flex' >

                {/* <div data-bs-toggle="modal" data-bs-target="#exampleModal"> */}
                <div onClick={handleShow}>
                    <img src={require("../assets/images/instructions.png")} className='mobielViewIcon' />
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="sectionsBox d-flex justify-content-between" style={{ display: "flex", }}>
                        <div></div>
                        <p className="mb-0 text-center" style={{ marginLeft: 10 }}>{getText(translations.ikigai, language)}</p>
                        <div style={{ marginRight: 10 }} onClick={handleCapture} ><FontAwesomeIcon icon={faDownload} size="lg" color="#fff" /></div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 ">
                    <div className="contentbox mb-2 mt-3">
                        <div className="content_safty ">
                            {getText(translations.internet_ikigai, language)}
                        </div>
                    </div>
                </div>
            </div>

            <div className="row" ref={captureRef}>
                <div className="col-12 ">
                    <div className="mb-2 mt-3 position-relative set_height">
                        <div className='cercleBoxes'>
                            <div className="circle circle1"></div>
                            <div className="circle circle2"></div>
                            <div className="circle circle3"></div>
                            <div className="circle circle4"></div>
                            {
                                textOptions?.map((item, index) => (
                                    <span className={`intersect-text text-center${index + 1}`} key={index}>{getText(item.title, language)}</span>
                                ))
                            }
                            {textInputs?.map((item, index) => (
                                <div className={`TextInput${index + 1}`} key={item.id}>
                                    <textarea
                                        name={index + 1}
                                        className={`text-input${(index === 0 || index === 3) ? "" : "-even"}`}
                                        placeholder={getText(item?.title, language)}
                                        style={{ backgroundColor: "transparent", fontSize: "10px", textAlign: "justify", textAlignLast: "center", whiteSpace: "normal" }}
                                        value={item?.text}
                                        onChange={(e) => { handleInputChange(e, (index + 1)) }}
                                        disabled={isMarked === 1 ? true : false}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <ModalInstruction show={show} handleClose={handleClose} inst={getText(translations.activity_instruction, language)} />

        </>
    );
};

export default Ikigai;
